import React, { ReactElement } from 'react';

import * as S from './InformationCard.styles';

type InformationCardProps = {
  title: string;
  description: string;
  imageSrc: string;
}

export const InformationCard = ({ title, description, imageSrc }: InformationCardProps): ReactElement => {
  const parts = title.split(/(\*[^*]+\*)/g);

  return (
    <S.Wrapper>
      <S.Image src={imageSrc} />
      <S.TextWrapper>
        <S.Title>
        {parts.map((part, index) => {
          // If part starts and ends with an asterisk, remove them and render as italic text.
          if (part.startsWith("*") && part.endsWith("*")) {
            return <S.ItalicTitle key={index}>{part.slice(1, -1)}</S.ItalicTitle>;
          }
          // Otherwise render normally
          return <span key={index}>{part}</span>;
        })}
        </S.Title>
        <S.Description>
         {description}
        </S.Description>
      </S.TextWrapper>
    </S.Wrapper>
  );
};
